/* Brando grouped reviews — renders the product-page review list.
 * Initial data comes from the product's brando_reviews.summary metafield (embedded as JSON);
 * other pages and star filters come from the brando-reviews-display API.
 * Texts and visibility come from the section's theme-editor settings (data-* attributes). */
(function () {
  "use strict";

  var T = {
    reviews: function (n) { return n === 1 ? "1 anmeldelse" : Number(n).toLocaleString("nb-NO") + " anmeldelser"; },
    basedOn: function (n) { return "Basert på " + T.reviews(n); },
    verified: "Verifisert kjøper",
    colour: "Farge",
    reply: "Svar fra Brando",
    prev: "Forrige",
    next: "Neste",
    page: function (n) { return "Side " + n; },
    showAll: "Vis alle",
    filtered: function (star, n, photos) {
      return T.reviews(n) + " med " + (star ? star + " stjerner" + (photos ? " og bilder" : "") : "bilder");
    },
    photosToggle: "Med bilder",
    gallery: "Bilder fra kundene",
    openPhoto: function (i, n, author) { return "Bilde " + i + " av " + n + " fra " + author + ", åpne"; },
    morePhotos: function (n) { return "Vis alle " + n + " bildene"; },
    slide: function (i, n) { return "Bilde " + i + " av " + n; },
    photoBy: function (author) { return "Bilde fra " + author; },
    close: "Lukk",
    prevPhoto: "Forrige bilde",
    nextPhoto: "Neste bilde",
    none: "Ingen anmeldelser ennå.",
    noMatch: "Ingen anmeldelser passer valget.",
    sortLabel: "Sorter",
    sorts: [["newest", "Nyeste"], ["highest", "Høyest vurdert"], ["lowest", "Lavest vurdert"]],
    error: "Kunne ikke laste anmeldelsene. Prøv igjen.",
    stars: function (r) { return r + " av 5 stjerner"; },
    fitScale: ["For liten", "Passer som forventet", "For stor"],
    fitCount: function (n) { return "Basert på " + Number(n).toLocaleString("nb-NO") + " svar"; },
    fitLabel: function (score, n) {
      var where = score < 0.15 ? "for liten" : score < 0.4 ? "litt liten" : score <= 0.6 ? "passer som forventet" : score <= 0.85 ? "litt stor" : "for stor";
      return "Gjennomsnittlig passform: " + where + ", " + T.fitCount(n).toLowerCase();
    },
  };

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  function stars(rating, cls) {
    var wrap = el("span", "br-stars " + (cls || ""));
    wrap.setAttribute("role", "img");
    wrap.setAttribute("aria-label", T.stars(Number(rating).toFixed(1).replace(".", ",")));
    for (var i = 1; i <= 5; i++) {
      var fill = Math.max(0, Math.min(1, rating - (i - 1)));
      var s = el("span", "br-star");
      s.style.setProperty("--fill", Math.round(fill * 100) + "%");
      s.setAttribute("aria-hidden", "true");
      wrap.appendChild(s);
    }
    return wrap;
  }

  /** A square photo of a fixed size, set on the element: the theme's global img rule would otherwise stretch it full width. */
  function thumb(src, size) {
    var img = el("img");
    img.src = src;
    img.loading = "lazy";
    img.alt = "";
    img.width = size;
    img.height = size;
    img.style.cssText = "width:" + size + "px;height:" + size + "px;max-width:" + size + "px;object-fit:cover;border-radius:8px;display:block";
    return img;
  }

  function getJson(url) {
    return fetch(url).then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); });
  }

  function formatDate(iso) {
    try {
      return new Date(iso).toLocaleDateString("nb-NO", { day: "numeric", month: "long", year: "numeric" });
    } catch (e) {
      return iso.slice(0, 10);
    }
  }

  function renderReview(r, opts) {
    var item = el("article", "br-review");
    item.setAttribute("data-review-id", r.id);

    var head = el("div", "br-review__head");
    head.appendChild(stars(r.rating, "br-stars--sm"));
    head.appendChild(el("time", "br-review__date", formatDate(r.createdAt))).setAttribute("datetime", r.createdAt);
    item.appendChild(head);

    var who = el("div", "br-review__who");
    who.appendChild(el("span", "br-review__author", r.author));
    if (r.verified && opts.showVerified) who.appendChild(el("span", "br-review__verified", T.verified));
    item.appendChild(who);

    var meta = el("div", "br-review__meta");
    if (r.variantLabel && opts.showColour) {
      var linked = r.productHandle && String(r.productId) !== String(opts.productId);
      var colour = el(linked ? "a" : "span", "br-chip br-review__colour", T.colour + ": " + r.variantLabel);
      if (linked) colour.href = "/products/" + encodeURIComponent(r.productHandle);
      meta.appendChild(colour);
    }
    if (opts.showFit) {
      (r.answers || []).forEach(function (a) {
        meta.appendChild(el("span", "br-chip br-review__answer", a.question + ": " + a.answer));
      });
    }
    if (meta.childNodes.length) item.appendChild(meta);

    if (r.title && r.body.indexOf(r.title.replace(/[\s–-]+$/, "")) !== 0) item.appendChild(el("h3", "br-review__title", r.title));
    if (r.body) {
      var body = el("div", "br-review__body");
      r.body.split(/\n{2,}/).forEach(function (para) {
        var p = el("p");
        para.split("\n").forEach(function (line, i) {
          if (i) p.appendChild(document.createElement("br"));
          p.appendChild(document.createTextNode(line));
        });
        body.appendChild(p);
      });
      item.appendChild(body);
    }

    if (r.pictures && r.pictures.length) {
      var pics = el("div", "br-review__pics");
      r.pictures.forEach(function (pic) {
        var a = el("a", "br-review__pic");
        a.href = pic.large;
        a.target = "_blank";
        a.rel = "noopener";
        a.appendChild(thumb(pic.small, 88));
        pics.appendChild(a);
      });
      item.appendChild(pics);
    }

    if (r.replyHtml) {
      var reply = el("div", "br-review__reply");
      reply.appendChild(el("div", "br-review__reply-label", opts.replyLabel || T.reply));
      var content = el("div", "br-review__reply-body");
      // Sanitised server-side (sanitize-html allowlist: p, br, b, i, a[href], lists).
      content.innerHTML = r.replyHtml;
      reply.appendChild(content);
      item.appendChild(reply);
    }
    return item;
  }

  /** Read-only slider: a marker at the average fit between too small (0) and too large (1). */
  function renderFitSlider(box, fit) {
    var scale = el("div", "br-fit__scale");
    scale.setAttribute("role", "img");
    scale.setAttribute("aria-label", T.fitLabel(fit.score, fit.total));
    var track = el("div", "br-fit__track");
    var marker = el("span", "br-fit__marker");
    marker.style.left = fit.score * 100 + "%";
    track.appendChild(marker);
    scale.appendChild(track);
    var labels = el("div", "br-fit__scale-labels");
    T.fitScale.forEach(function (text) { labels.appendChild(el("span", "br-fit__scale-label", text)); });
    scale.appendChild(labels);
    box.appendChild(scale);
    box.appendChild(el("div", "br-fit__count", T.fitCount(fit.total))).setAttribute("aria-hidden", "true");
  }

  /** Bars with % per answer: summaries written before fit.score existed. */
  function renderFitBars(box, fit) {
    fit.answers.forEach(function (a) {
      var pct = Math.round((a.count / fit.total) * 100);
      var row = el("div", "br-fit__row");
      row.appendChild(el("span", "br-fit__label", a.answer));
      var bar = el("span", "br-fit__bar");
      var fill = el("span", "br-fit__fill");
      fill.style.width = pct + "%";
      bar.appendChild(fill);
      row.appendChild(bar);
      row.appendChild(el("span", "br-fit__pct", pct + " %"));
      box.appendChild(row);
    });
  }

  function renderFit(fit) {
    var box = el("div", "br-fit");
    box.appendChild(el("div", "br-fit__title", fit.question));
    if (typeof fit.score === "number") renderFitSlider(box, fit);
    else renderFitBars(box, fit);
    return box;
  }

  function renderSummary(data, opts, onFilter) {
    var box = el("div", "br-summary");
    var left = el("div", "br-summary__score");
    left.appendChild(el("div", "br-summary__avg", data.average.toFixed(1).replace(".", ",")));
    left.appendChild(stars(data.average, "br-stars--lg"));
    left.appendChild(el("div", "br-summary__count", T.basedOn(data.count)));
    if (opts.grouped && opts.groupNote) left.appendChild(el("div", "br-summary__note", opts.groupNote));
    box.appendChild(left);

    if (opts.showHistogram) {
      var hist = el("div", "br-histogram");
      for (var s = 5; s >= 1; s--) {
        var n = data.histogram[String(s)] || 0;
        var row = el("button", "br-histogram__row");
        row.type = "button";
        row.disabled = n === 0;
        row.setAttribute("data-rating", s);
        row.setAttribute("aria-label", T.filtered(s, n));
        row.appendChild(el("span", "br-histogram__label", s + " ★"));
        var bar = el("span", "br-histogram__bar");
        var fill = el("span", "br-histogram__fill");
        fill.style.width = (data.count ? Math.round((n / data.count) * 100) : 0) + "%";
        bar.appendChild(fill);
        row.appendChild(bar);
        row.appendChild(el("span", "br-histogram__n", String(n)));
        row.addEventListener("click", function (e) { onFilter(Number(e.currentTarget.getAttribute("data-rating"))); });
        hist.appendChild(row);
      }
      box.appendChild(hist);
    }
    if (opts.showFit && data.fit && data.fit.total) box.appendChild(renderFit(data.fit));
    return box;
  }

  var ICON_CLOSE = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICON_PREV = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 6l-6 6 6 6"/></svg>';
  var ICON_NEXT = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>';

  function iconButton(cls, label, icon) {
    var b = el("button", "br-viewer__btn " + cls);
    b.type = "button";
    b.setAttribute("aria-label", label);
    b.innerHTML = icon;
    return b;
  }

  /**
   * Full-screen photo viewer: a native <dialog> with one scroll-snapped slide per photo, ported from the
   * theme's social-gallery viewer (BRA-2011). Swipe or arrow keys move between photos; the close button,
   * Escape, a click beside the photo and the browser's Back button all close it, and focus returns to the tile.
   */
  function createViewer(host, opts) {
    var dialog = el("dialog", "br-viewer");
    dialog.setAttribute("aria-label", T.gallery);
    var count = el("p", "br-viewer__count");
    count.setAttribute("aria-live", "polite");
    var closeBtn = iconButton("br-viewer__close", T.close, ICON_CLOSE);
    var slides = el("div", "br-viewer__slides");
    var prev = iconButton("br-viewer__arrow br-viewer__arrow--prev", T.prevPhoto, ICON_PREV);
    var next = iconButton("br-viewer__arrow br-viewer__arrow--next", T.nextPhoto, ICON_NEXT);
    dialog.appendChild(count);
    dialog.appendChild(closeBtn);
    dialog.appendChild(slides);
    dialog.appendChild(prev);
    dialog.appendChild(next);
    host.appendChild(dialog);
    var open = null;

    function renderSlide(p, i, n, eager) {
      var slide = el("div", "br-viewer__slide");
      slide.setAttribute("role", "group");
      slide.setAttribute("aria-label", T.slide(i + 1, n));
      var media = el("div", "br-viewer__media");
      var img = el("img", "br-viewer__img");
      img.src = p.large;
      img.alt = T.photoBy(p.author);
      img.loading = eager ? "eager" : "lazy";
      // Contained in its box whatever the theme's global img rule says.
      img.style.cssText = "width:100%;height:100%;max-width:100%;max-height:100%;object-fit:contain;display:block;margin:0";
      media.appendChild(img);
      slide.appendChild(media);
      var caption = el("div", "br-viewer__caption");
      var head = el("div", "br-viewer__head");
      head.appendChild(stars(p.rating, "br-stars--sm"));
      head.appendChild(el("span", "br-viewer__author", p.author));
      if (p.colour && opts.showColour) head.appendChild(el("span", "br-chip br-viewer__colour", T.colour + ": " + p.colour));
      caption.appendChild(head);
      if (p.body) caption.appendChild(el("p", "br-viewer__body", p.body));
      slide.appendChild(caption);
      return slide;
    }

    function current() {
      return Math.round(slides.scrollLeft / Math.max(slides.clientWidth, 1));
    }

    function go(index) {
      var n = slides.children.length;
      slides.scrollTo({ left: Math.max(0, Math.min(n - 1, index)) * slides.clientWidth, behavior: "smooth" });
    }

    function update() {
      if (!open) return;
      var i = current();
      if (i === open.index) return;
      open.index = i;
      count.textContent = T.slide(i + 1, open.n);
      prev.disabled = i === 0;
      next.disabled = i === open.n - 1;
    }

    function show(photos, index, tile) {
      if (typeof dialog.showModal !== "function") {
        // Safari before 15.4 has no <dialog>: open the large image instead, as the review thumbnails do.
        window.open(photos[index].large, "_blank", "noopener");
        return;
      }
      slides.innerHTML = "";
      photos.forEach(function (p, i) { slides.appendChild(renderSlide(p, i, photos.length, Math.abs(i - index) <= 1)); });
      open = { tile: tile, n: photos.length, index: -1, token: null };
      dialog.classList.toggle("is-single", photos.length === 1);
      dialog.showModal();
      document.documentElement.classList.add("br-lock");
      slides.scrollLeft = index * slides.clientWidth;
      update();
      closeBtn.focus({ preventScroll: true });
      try {
        var token = "br-viewer-" + Date.now();
        history.pushState({ brandoReviewsViewer: token }, "");
        open.token = token;
      } catch (e) {}
    }

    // Our history entry is the current one: Back has not been pressed and no other script navigated since.
    function ownsEntry(token) {
      return token != null && history.state != null && history.state.brandoReviewsViewer === token;
    }

    // object-fit: contain paints the photo inside the img box; the bars beside it count as backdrop.
    function onPaintedPhoto(img, x, y) {
      var r = img.getBoundingClientRect();
      if (!img.naturalWidth || !img.naturalHeight) return true;
      var scale = Math.min(r.width / img.naturalWidth, r.height / img.naturalHeight);
      var w = img.naturalWidth * scale;
      var h = img.naturalHeight * scale;
      var left = r.left + (r.width - w) / 2;
      var top = r.top + (r.height - h) / 2;
      return x >= left && x <= left + w && y >= top && y <= top + h;
    }

    // Every way out ends here: the X, a click beside the photo and Escape close the dialog (→ "close"
    // event), and Back arrives through popstate (fromHistory).
    function close(fromHistory) {
      if (!open) return;
      var was = open;
      open = null;
      if (dialog.open) dialog.close();
      slides.innerHTML = "";
      document.documentElement.classList.remove("br-lock");
      if (was.tile && was.tile.isConnected) was.tile.focus({ preventScroll: true });
      if (!fromHistory && ownsEntry(was.token)) history.back();
    }

    slides.addEventListener("scroll", update, { passive: true });
    prev.addEventListener("click", function () { go(current() - 1); });
    next.addEventListener("click", function () { go(current() + 1); });
    closeBtn.addEventListener("click", function () { dialog.close(); });
    dialog.addEventListener("click", function (e) {
      var t = e.target;
      if (t.classList.contains("br-viewer__img") ? !onPaintedPhoto(t, e.clientX, e.clientY) : !t.closest(".br-viewer__caption, .br-viewer__btn, .br-viewer__count")) dialog.close();
    });
    dialog.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") { e.preventDefault(); go(current() - 1); }
      else if (e.key === "ArrowRight") { e.preventDefault(); go(current() + 1); }
    });
    dialog.addEventListener("close", function () { close(false); });
    // Back from our entry closes; history moves that land on our entry (or happen while closed) do not.
    window.addEventListener("popstate", function () { if (open && !ownsEntry(open.token)) close(true); });
    return { show: show };
  }

  /** 1 … 4 5 [6] 7 8 … 20 */
  function pageNumbers(current, last) {
    var out = [];
    for (var i = 1; i <= last; i++) {
      if (i === 1 || i === last || Math.abs(i - current) <= 1) out.push(i);
      else if (out[out.length - 1] !== "…") out.push("…");
    }
    return out;
  }

  function init(root) {
    if (root.__brReviews) return;
    root.__brReviews = true;
    var dataEl = root.querySelector("script[type='application/json']");
    var summary = null;
    try { summary = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { summary = null; }
    var api = root.getAttribute("data-api");
    var attr = function (name, dflt) { var v = root.getAttribute("data-" + name); return v == null ? dflt : v; };
    var opts = {
      productId: attr("product-id", ""),
      perPage: Number(attr("per-page", 5)) || 5,
      grouped: attr("grouped", "false") === "true",
      groupNote: attr("group-note", "Gjelder alle farger av denne varen"),
      replyLabel: attr("reply-label", T.reply),
      showHistogram: attr("show-histogram", "true") !== "false",
      showColour: attr("show-colour", "true") !== "false",
      showVerified: attr("show-verified", "true") !== "false",
      showFit: attr("show-fit", "true") !== "false",
      showSort: attr("show-sort", "true") !== "false",
      showPhotos: attr("show-photos", "true") !== "false",
    };
    var mount = root.querySelector(".br-mount") || root;

    if (!summary || !summary.count) {
      mount.appendChild(el("p", "br-empty", attr("empty-text", T.none)));
      return;
    }

    var state = { rating: null, photos: false, sort: "newest", page: 1, total: summary.count, requestId: 0 };
    // Summaries carry `photos`/`photoCount` only when the group has photos.
    var photoCount = (opts.showPhotos && summary.photoCount) || 0;
    var list = el("div", "br-list");
    list.setAttribute("aria-live", "polite");
    var toolbar = el("div", "br-toolbar");
    var filterBar = el("div", "br-filterbar");
    var photoToggle = null;
    if (photoCount && api != null) {
      photoToggle = el("button", "br-photos-toggle", T.photosToggle);
      photoToggle.type = "button";
      photoToggle.setAttribute("aria-pressed", "false");
      photoToggle.addEventListener("click", function () { state.photos = !state.photos; filtersChanged(); });
      toolbar.appendChild(photoToggle);
    }
    toolbar.appendChild(filterBar);
    var sortSelect = null;
    if (opts.showSort && api != null && summary.count > 1) {
      var sortWrap = el("label", "br-sort");
      sortWrap.appendChild(el("span", "br-sort__label", T.sortLabel));
      sortSelect = el("select", "br-sort__select");
      T.sorts.forEach(function (s) { sortSelect.appendChild(new Option(s[1], s[0])); });
      sortSelect.addEventListener("change", function () { state.sort = sortSelect.value; go(1, false); });
      sortWrap.appendChild(sortSelect);
      toolbar.appendChild(sortWrap);
    }

    function renderFilterBar(n) {
      filterBar.innerHTML = "";
      if (!state.rating && !state.photos) return;
      filterBar.appendChild(el("span", null, T.filtered(state.rating, n, state.photos)));
      var clear = el("button", "br-filterbar__clear", T.showAll);
      clear.type = "button";
      clear.addEventListener("click", function () { state.rating = null; state.photos = false; filtersChanged(); });
      filterBar.appendChild(clear);
    }

    // Customer photos: the summary's first ones as a strip of tiles; "Vis alle" loads the rest from the API.
    var photos = photoCount ? (summary.photos || []).slice() : [];
    var viewer = null;
    var gallery = null;
    var strip = null;
    function addTile(cls, label, onClick) {
      var item = el("div", "br-gallery__item");
      item.setAttribute("role", "listitem");
      var tile = el("button", "br-gallery__tile " + cls);
      tile.type = "button";
      // Inline like the img's: theme button rules must not resize the tile.
      tile.style.cssText = "width:88px;height:88px";
      tile.setAttribute("aria-label", label);
      tile.addEventListener("click", function () { onClick(tile); });
      item.appendChild(tile);
      strip.appendChild(item);
      return tile;
    }
    function renderStrip(focusIndex) {
      strip.innerHTML = "";
      photos.forEach(function (p, i) {
        var tile = addTile("", T.openPhoto(i + 1, photos.length, p.author), function (t) {
          viewer = viewer || createViewer(root, opts);
          viewer.show(photos, i, t);
        });
        tile.setAttribute("aria-haspopup", "dialog");
        tile.appendChild(thumb(p.small, 88));
      });
      if (photoCount > photos.length) {
        var more = addTile("br-gallery__more", T.morePhotos(photoCount), loadAllPhotos);
        more.appendChild(el("span", "br-gallery__more-n", "+" + (photoCount - photos.length)));
        more.appendChild(el("span", null, T.showAll));
      }
      var focus = strip.querySelectorAll(".br-gallery__tile")[focusIndex];
      if (focus) focus.focus();
    }
    if (photos.length) {
      gallery = el("div", "br-gallery");
      var title = el("h3", "br-gallery__title", T.gallery);
      var galleryN = el("span", "br-gallery__n", " (" + photoCount + ")");
      title.appendChild(galleryN);
      gallery.appendChild(title);
      strip = el("div", "br-gallery__strip");
      strip.setAttribute("role", "list");
      gallery.appendChild(strip);
      renderStrip(-1);
    }

    function loadAllPhotos(button) {
      button.disabled = true;
      var reviews = [];
      function more(page) {
        return getJson(reviewsUrl(page, null, true, "newest", 50)).then(function (data) {
          reviews = reviews.concat(data.reviews);
          if (data.reviews.length && reviews.length < data.total) return more(page + 1);
        });
      }
      more(1).then(function () {
        var shown = photos.length;
        photos = [];
        reviews.forEach(function (r) {
          r.pictures.forEach(function (p) {
            photos.push({ small: p.small, large: p.large, reviewId: r.id, rating: r.rating, author: r.author, colour: r.variantLabel, body: r.body });
          });
        });
        photoCount = photos.length;
        galleryN.textContent = " (" + photoCount + ")";
        renderStrip(shown);
      }).catch(function () { button.disabled = false; });
    }
    var pager = el("nav", "br-pager");
    pager.setAttribute("aria-label", "Sider med anmeldelser");
    var status = el("p", "br-status");

    function renderList(reviews) {
      list.innerHTML = "";
      reviews.forEach(function (r) { list.appendChild(renderReview(r, opts)); });
    }

    function renderPager() {
      pager.innerHTML = "";
      var last = Math.max(1, Math.ceil(state.total / opts.perPage));
      if (last <= 1) return;
      function btn(label, page, step, aria) {
        var b = el("button", "br-page" + (step ? " br-page--step" : ""), label);
        b.type = "button";
        if (aria) b.setAttribute("aria-label", aria);
        if (!step && page === state.page) {
          b.setAttribute("aria-current", "page");
          b.classList.add("is-current");
        }
        if (page < 1 || page > last) b.disabled = true;
        else b.addEventListener("click", function () { go(page, true); });
        return b;
      }
      pager.appendChild(btn("‹", state.page - 1, true, T.prev));
      pageNumbers(state.page, last).forEach(function (p) {
        if (p === "…") pager.appendChild(el("span", "br-page__gap", "…"));
        else pager.appendChild(btn(String(p), p, false, T.page(p)));
      });
      pager.appendChild(btn("›", state.page + 1, true, T.next));
    }

    function scrollToTop() {
      // Only when the top of the section is above the viewport (the shopper scrolled down to the pager).
      if (root.getBoundingClientRect().top < 0) root.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    // Fixed parameter order, so the same view is the same URL (browser cache, max-age=60).
    function reviewsUrl(page, rating, photos, sort, perPage) {
      return api + "/api/reviews?product_id=" + encodeURIComponent(opts.productId) + "&per_page=" + perPage + "&page=" + page +
        (rating ? "&rating=" + rating : "") + (photos ? "&photos=1" : "") + "&sort=" + sort;
    }

    function go(page, fromPager) {
      state.page = page;
      status.textContent = "";
      // Every navigation invalidates responses still in flight, including the embedded path below.
      var id = ++state.requestId;
      root.classList.remove("is-loading");
      var embedded = summary.reviews || [];
      // Page 1 unfiltered in the default order renders straight from the metafield when it holds a full page.
      if (page === 1 && !state.rating && !state.photos && state.sort === "newest" && embedded.length >= Math.min(opts.perPage, summary.count)) {
        state.total = summary.count;
        renderList(embedded.slice(0, opts.perPage));
        renderPager();
        if (fromPager) scrollToTop();
        return;
      }
      if (api == null) return;
      root.classList.add("is-loading");
      // A new sort or filter changes the page count: the old pager must not be clickable while this loads.
      if (!fromPager) pager.innerHTML = "";
      getJson(reviewsUrl(page, state.rating, state.photos, state.sort, opts.perPage))
        .then(function (data) {
          if (id !== state.requestId) return;
          state.total = data.total;
          // The filter bar counts what the API found: with "Med bilder" that is not the histogram's count.
          if (state.rating || state.photos) renderFilterBar(data.total);
          renderList(data.reviews);
          if (!data.reviews.length) status.textContent = T.noMatch;
          renderPager();
          if (fromPager) scrollToTop();
        })
        .catch(function () { if (id === state.requestId) status.textContent = T.error; })
        .then(function () { if (id === state.requestId) root.classList.remove("is-loading"); });
    }

    function setFilter(rating) {
      state.rating = state.rating === rating ? null : rating;
      filtersChanged();
    }

    // A star and "Med bilder" combine; either change starts again on page 1.
    function filtersChanged() {
      Array.prototype.forEach.call(root.querySelectorAll(".br-histogram__row"), function (b) {
        b.classList.toggle("is-active", Number(b.getAttribute("data-rating")) === state.rating);
      });
      if (photoToggle) {
        photoToggle.classList.toggle("is-active", state.photos);
        photoToggle.setAttribute("aria-pressed", String(state.photos));
      }
      // A star alone is counted by the histogram; with photos the count waits for the API's total.
      if (state.photos) filterBar.innerHTML = "";
      else renderFilterBar(summary.histogram[String(state.rating)] || 0);
      go(1, false);
    }

    if (gallery) mount.appendChild(gallery);
    mount.appendChild(renderSummary(summary, opts, setFilter));
    // Without a sort or photo toggle the filter bar stands alone and collapses when no filter is on.
    mount.appendChild(photoToggle || sortSelect ? toolbar : filterBar);
    mount.appendChild(list);
    mount.appendChild(status);
    mount.appendChild(pager);
    go(1, false);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll("[data-brando-reviews]"), init);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
  window.BrandoReviews = { init: init, stars: stars };
})();
